import { _ as t } from "../internals/export.js";
import { m as a } from "../internals/math-log1p.js";
var r = Math.acosh,
  o = Math.log,
  s = Math.sqrt,
  h = Math.LN2;
t({
  target: "Math",
  stat: !0,
  forced: !r || 710 != Math.floor(r(Number.MAX_VALUE)) || r(1 / 0) != 1 / 0
}, {
  acosh: function acosh(t) {
    var r = +t;
    return r < 1 ? NaN : r > 94906265.62425156 ? o(r) + h : a(r - 1 + s(r - 1) * s(r + 1));
  }
});